import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CopperLayer from "../components/Copper/CopperLayer";
import CopperSummary from "../components/Copper/CopperSummary";
import { COPPER_SECTIONS } from "../components/Copper/copperConfig";

const TITLES = {
  summary: "Summary",
  wallets: "Wallets / Balances",
  portfolios: "Portfolios",
  currencies: "Currencies",
  orders: "Orders (Buy / Sell)",
  transfers: "Transfers",
  trades: "Trades",
  addresses: "Addresses",
};

const CopperPage = () => {
  const { section } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("AdminAuthToken");
    if (!token) navigate("/");
  }, [navigate]);

  const isSummary = section === "summary";
  const isKnownList = !!COPPER_SECTIONS[section];
  const title = TITLES[section] || "Copper";

  return (
    <MasterLayout>
      <Breadcrumb title={`Copper · ${title}`} />
      {isSummary ? (
        <CopperSummary />
      ) : isKnownList ? (
        <CopperLayer section={section} />
      ) : (
        <div style={{ padding: 24, color: "#64748b" }}>
          Unknown Copper section "{section}".
        </div>
      )}
    </MasterLayout>
  );
};

export default CopperPage;
